import { HTTPError } from "../httpError";
import { ContentsManager } from "./manager";

// https://github.com/jupyter/notebook/blob/master/notebook/services/contents/filemanager.py#L66
export class FileManager extends ContentsManager {
  static contentResolve: (content: string) => void | undefined;
  private static getContentPromise() {
    return new Promise<string>(
      resolve => (FileManager.contentResolve = resolve)
    );
  }
  static contentPromise = FileManager.getContentPromise();

  async get(
    path: string,
    type: string,
    _format: string,
    includeContent: number
  ) {
    if (type === "directory" || path === "") {
      return this.buildDirectory();
    }

    // Actual notebook content handled by outer frame.
    if (!includeContent) {
      return this.buildModel();
    }

    const content = await FileManager.contentPromise;
    // Reset promise for next request.
    FileManager.contentPromise = FileManager.getContentPromise();

    if (!content) {
      throw new Error(
        "Received 'null' content in FileManager API interception"
      );
    }

    return {
      ...this.buildModel(),
      content: JSON.parse(content),
      size: content.length,
    };
  }

  async fileExists(_path: string) {
    return Promise.resolve(true);
  }

  async save(model: any, path: string) {
    if (typeof model.type === "undefined") {
      throw new HTTPError(400, "No file type provided");
    }
    if (typeof model.content === "undefined") {
      throw new HTTPError(400, "No file content provided");
    }

    try {
      if (model.type === "notebook") {
        return await this.saveNotebook(path, model.content);
      } else if (model.type === "file") {
        throw new Error("Method not implemented");
      } else if (model.type === "directory") {
        throw new Error("Method not implemented");
      } else {
        throw new HTTPError(400, `Unhandled contents type: ${model.type}`);
      }
    } catch (error) {
      throw new HTTPError(
        500,
        `Unhandled error while saving file: ${path} ${error}`
      );
    }
  }

  private async saveNotebook(_path: string, _content: string) {
    // No-op since this is handled through auto-saves in the outer frame.
    return this.buildModel();
  }

  private buildDirectory() {
    return {
      name: "",
      path: "",
      last_modified: "2020-09-16T14:53:17.524718Z",
      created: "2020-09-16T14:53:17.524718Z",
      content: [
        {
          name: "__notebook_source__.ipynb",
          path: "__notebook_source__.ipynb",
          last_modified: "2020-09-16T14:48:59Z",
          created: "2020-09-16T14:48:59.507405Z",
          content: null,
          format: null,
          mimetype: null,
          size: 263,
          writable: true,
          type: "notebook",
        },
      ],
      format: "json",
      mimetype: null,
      size: null,
      writable: true,
      type: "directory",
    };
  }

  private buildModel() {
    return {
      content: null,
      created: "2000-01-01T00:00:00.000000Z",
      last_modified: "2000-01-01T00:00:00.000000Z",
      format: "json",
      mimetype: null,
      size: 0,
      writable: true,
      type: "notebook",
      name: "__notebook_source__.ipynb",
      path: "__notebook_source__.ipynb",
    };
  }
}
